// List: https://docs.google.com/spreadsheets/d/10H6CRoCg4ZltW2sHnaDItYs4S0hc4qELMrp_oB4ieqg/edit?gid=0#gid=0

const excludedPackages = [
	352, 1957, 569, 3, 562, 1771, 192, 33, 349, 1764, 35, 1993, 40, 456, 61, 224, 1862, 641, 2237, 2149, 1948, 73, 621,
	464,
];

export function excludePackages(isLoggedIn: boolean, entityId: string, country: string) {
	// don't exclude any packages when logged in, except for Nordisk temporarily
	if (isLoggedIn) return ['US', 'IN'].includes(country) ? [621] : [621, 73];

	return excludedPackages.filter(packageId => {
		// allow Tubi in IN
		const isTubiInIN = packageId === 73 && country === 'IN';

		return !isTubiInIN;
	});
}
